import styled from 'styled-components';
import { rgba } from 'polished';

import { cFFFFFF } from '#/colors';

const BaseContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 16px;
  background: transparent;
  backdrop-filter: blur(25px);
  color: ${rgba(cFFFFFF, 0.7)};
  padding: 16px;
  padding-right: 42px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
`;

export default BaseContainer;
